'use client';
import { useEffect, useState } from 'react';
import {
    IFormatedData_SELL,
    ILocationDropDown,
    useSellCarNew,
    useTranslation,
    useWindowDimensions,
} from '@/hook';
import {
    useAddLeadMutation,
    useAddPerspectiveLeadMutation,
    useLazyGetMakesV3Query,
    useLazyGetModelsV3Query,
    useLazyGetRegionsQuery,
} from '@/hook/acquisition-api-slice';

import {
    IContanctInfo_SELL,
    ISpecificContactTime,
    IStepperItem_SELL_NEW,
} from '@/types';
import {
    ContactInfoForm,
    LocationFormContent,
    SelectFormContent,
    SelectInspectionType,
    SellCarMobileHeader,
    SellFormMobileContetnLayout,
    StepperSteps,
    LocationMapForm,
} from '@/components/sell-car-form';

import { usePathname, useRouter } from 'next/navigation';
import Conditional from '@/components/shared/conditional/conditional.component';
import {
    SELL_CAR_FORM_DATA_FULL_MOBILE,
    SELL_CAR_FORM_DATA_FULL_MOBILE_VARIATION,
    STEPPER_STEPS_FULL_DATA_MOBILE,
    STEPPER_STEPS_FULL_DATA_MOBILE_VARIOATION,
} from '@/hook/acquisition/sell-car-form-data-stepper-variations';

const SellCarForm = () => {
    // const {
    // getStepperLastActiveStep,
    // getTotalStepperSteps,
    // stepper,
    // formatMakesForDisplay,
    // formatModelsForDisplay,
    // setChoosenData,
    // getYearsKmFromTargetModel,
    // getKmFromTargetModel,
    // formatRegionsForDisplay,
    // setChoosenDataRegion,
    // setSellerContactInfo,
    // getCurrentActiveStep,
    // currentStep,
    // getMake,
    // getModel,
    // getKilometers,
    // getYear,
    // getRegion,
    // getPath,
    // getTransmission,
    // getTrafficPoint,
    // buildLeadObject,
    // buildPerspectiveLeadObject,
    // triggerVerificationEvent,
    // getContactInfo,
    // goBackToPreviousStep,
    // clearForm,
    // getDisclaimerText,
    // shouldShowAlert,
    // buildFormDataObjectFromMakeModel,
    // buildFormDataObjectFromYear,
    // buildFormDataObjectFromKilometers,
    // buildFormDataObjectFromTransmission,
    // getTrafficPointOptions,
    // getTransmissionOptionsFromYear,
    // buildFormDataObjectFromTrafficPoint,
    // buildFormDataObjectFromRegion,
    // triggerVerificationEventPath1,
    // triggerVerificationEventPath2,
    // getAddContactTime,
    // triggerSpecificContactTimeEvent,
    // getContactTimeUsed,
    // getContactTimeObject,
    // setContactTimeObject,
    // setContactTimeUsed,
    // getOtherInfoFlag,
    // regionShowCheck,
    // getContactStep,
    // } = useSellCar();

    const {
        setChoosenData,
        getMake,
        getModel,
        getRegion,
        getYear,
        getKilometers,
        getContactInfo,
        getTransmission,
        getTrafficPoint,
        intializeSellCar,
        getPath,
        formatMakesForDisplay,
        formatModelsForDisplay,
        getTransmissionOptionsFromYear,
        getTrafficPointOptions,
        getYearsKmFromTargetModel,
        getKmFromTargetModel,
        formatRegionsForDisplay,
        buildFormDataObjectFromMakeModel,
        buildFormDataObjectFromYear,
        buildFormDataObjectFromKilometers,
        buildFormDataObjectFromTrafficPoint,
        buildFormDataObjectFromTransmission,
        buildFormDataObjectFromRegion,
        buildLeadObject,
        buildPerspectiveLeadObject,
        goBackToPreviousStep,
        getStepper,
        getCurrentActiveStep,
        goToTargetStep,
        triggerVerificationEvent,
        triggerVerificationEventPath1,
        triggerVerificationEventPath2,
        getDisclaimerText,
        clearForm,
        getExperimentFlag,
        getShowNewMap,
    } = useSellCarNew();

    const { i18n, t } = useTranslation();

    const { width } = useWindowDimensions();
    const router = useRouter();
    const path = usePathname();
    const IS_MOBILE = width <= 1100;

    const [step, setStep] = useState<IStepperItem_SELL_NEW>(
        getCurrentActiveStep()
    );
    const [trafficPointState, setTrafficPointState] = useState<
        IFormatedData_SELL[]
    >([]);
    const [transmissionState, setTransmissionState] = useState<
        IFormatedData_SELL[]
    >([]);
    useEffect(() => {
        const step = getCurrentActiveStep();
        // navigate(`/${i18n.language}/sell-form/${step?.label.toLocaleLowerCase()}`, { replace: false });

        setStep(step);
    }, [getCurrentActiveStep()]);

    const [makesState, setMakesState] = useState<IFormatedData_SELL[]>([]);
    const [modelstate, setModelstate] = useState<IFormatedData_SELL[]>([]);
    const [locationsState, setLocationsState] = useState<ILocationDropDown[]>(
        []
    );

    const [triggerRegions, { data: regions, isLoading: isLoadingRegions }] =
        useLazyGetRegionsQuery();

    const [
        trigger,
        {
            data,
            isLoading: isLoadingMakes,
            isError: isErrorMakes,
            isFetching: isFetchingMakes,
        },
    ] = useLazyGetMakesV3Query();
    const [
        triggerModels,
        {
            data: modelsData,
            isLoading: isLoadingModels,
            isError: isErrorModels,
            isFetching: isFetchingModels,
        },
    ] = useLazyGetModelsV3Query();

    const [
        addLead,
        {
            isLoading: isLoadingAddLead,
            isError: isErrorAddLead,
            isSuccess: isSuccessAddLead,
            error: errorAddLead,
            data: addLeadData,
        },
    ] = useAddLeadMutation();

    const [
        addPerspectiveLead,
        {
            isLoading: isLoadingAddPerspectiveLead,
            isError: isErrorAddPerspectiveLead,
            isSuccess: isSuccessAddPerspectiveLead,
            error: errorAddPerspectiveLead,
            data: addPerspectiveLeadData,
        },
    ] = useAddPerspectiveLeadMutation();

    const checkParamValidity = () => {
        const transmission = getTransmission();
        const trafficPoint = getTrafficPoint();
        const otherInfoFlag = true;
        const otherInfoNotFilled = otherInfoFlag
            ? transmission.transmission === '' ||
              trafficPoint.trafficPoint === ''
            : getKilometers().displayed === '';
        if (!IS_MOBILE) router.push(`/${i18n.language}/sell-car`);
        const stepUrlParamter = path;

        if (stepUrlParamter === 'make') return;

        if (stepUrlParamter === 'model') {
            const make = getMake();
            if (make.nameEn === '') router.push(`/${i18n.language}/sell-car`);
            return;
        }
        if (stepUrlParamter === 'year') {
            const model = getModel();
            if (model.nameEn === '') router.push(`/${i18n.language}/sell-car`);
            return;
        }
        if (stepUrlParamter === 'kilometers') {
            const year = getYear();
            if (year.year === '') router.push(`/${i18n.language}/sell-car`);
            return;
        }
        if (stepUrlParamter === 'otherinfo' && otherInfoFlag) {
            const km = getKilometers();
            if (km.displayed === '') router.push(`/${i18n.language}/sell-car`);
            return;
        }
        if (stepUrlParamter === 'region') {
            const otherInfoFlagCheck = otherInfoNotFilled;
            if (otherInfoFlagCheck) router.push(`/${i18n.language}/sell-car`);
            return;
        }
        if (stepUrlParamter === 'contactInfo') {
            const region = getRegion();
            const path = getPath();
            if (otherInfoNotFilled && path === 'path2')
                router.push(`/${i18n.language}/sell-car`);
            if (region?.smallArea === '' && path === 'path1')
                router.push(`/${i18n.language}/sell-car`);
            return;
        }
        if (stepUrlParamter === 'thank-you') {
            if (!isSuccessAddLead && !isSuccessAddPerspectiveLead) {
                router.push(`/${i18n.language}/sell-car`);
            }
            return;
        }
        // navigate(`/${i18n.language}/sell-car`);
    };
    if (regions && locationsState.length === 0) {
        const formatedRegions = formatRegionsForDisplay(
            regions
                .map(item => {
                    return {
                        ...item,
                        smallArea: item.smallArea,
                    };
                })
                .filter(item => item.smallArea.length)
        );
        setLocationsState(formatedRegions);
    }

    useEffect(() => {
        checkParamValidity();
    }, [path]);

    useEffect(() => {
        if (isSuccessAddLead || isSuccessAddPerspectiveLead) clearForm();
        checkParamValidity();
        if (!isLoadingMakes) trigger();
        if (!isLoadingRegions) triggerRegions();
    }, []);

    useEffect(() => {
        if (width < 1100 && getStepper().length === 0) {
            if (getExperimentFlag()) {
                intializeSellCar(
                    STEPPER_STEPS_FULL_DATA_MOBILE,
                    SELL_CAR_FORM_DATA_FULL_MOBILE
                );
            } else {
                intializeSellCar(
                    STEPPER_STEPS_FULL_DATA_MOBILE_VARIOATION,
                    SELL_CAR_FORM_DATA_FULL_MOBILE_VARIATION
                );
            }
        }
    }, [getExperimentFlag()]);

    useEffect(() => {
        const kilometers = getKilometers();
        if (!modelsData?.data || kilometers?.displayed === '') return;
        const transmissionData = getTransmissionOptionsFromYear(
            getYear(),
            modelsData?.data
        );
        setTransmissionState(transmissionData);

        const trafficPointData = getTrafficPointOptions(
            getYear(),
            modelsData?.data
        );

        setTrafficPointState(trafficPointData);
    }, [getKilometers(), getTrafficPoint(), getTransmission()]);

    useEffect(() => {
        const make = getMake();
        setModelstate([]);
        if (!isLoadingModels) triggerModels(make.id);
    }, [getMake()]);

    useEffect(() => {
        if (!isLoadingMakes && !isErrorMakes && !isFetchingMakes && data) {
            const formatedMakes = formatMakesForDisplay(data.data);
            setMakesState(formatedMakes);
        }
    }, [isLoadingMakes, isErrorMakes, isFetchingMakes]);

    useEffect(() => {
        if (
            !isLoadingModels &&
            !isErrorModels &&
            modelsData &&
            !isFetchingModels
        ) {
            const formatedModels = formatModelsForDisplay(modelsData.data);
            setModelstate(formatedModels);
        }
    }, [isLoadingModels, isErrorModels, isFetchingModels]);

    useEffect(() => {
        if (isSuccessAddLead && getPath() === 'path1') {
            triggerVerificationEventPath1(
                getContactInfo(),
                addLeadData.message._id
            );
            router.push(' ');
            triggerVerificationEvent(getContactInfo(), addLeadData.message._id);
            // if (getContactTimeUsed() && getAddContactTime()) {
            //   triggerSpecificContactTimeEvent(getContactTimeObject());
            //   setContactTimeUsed(false);
            //   setContactTimeObject({});
            // }
            router.push('sell-form/thankyou');
        }
        if (isSuccessAddPerspectiveLead && getPath() === 'path2') {
            triggerVerificationEventPath2(
                getContactInfo(),
                addPerspectiveLeadData.message._id
            );
            router.push(' ');

            router.push('sell-form/thankyou');
        }
    }, [isSuccessAddLead, isSuccessAddPerspectiveLead]);

    const submitForm = (
        key: 'contactInfo',
        item: IContanctInfo_SELL,
        otp: string,
        specificContactTime: ISpecificContactTime
    ) => {
        setChoosenData(key, item);
        const lang = i18n.language;

        const path = getPath();
        if (path === 'path1') {
            const leadObj = buildLeadObject(
                otp,
                lang,
                item,
                specificContactTime
            );
            addLead(leadObj);
        }
        if (path === 'path2') {
            const leadObj = buildPerspectiveLeadObject(lang, item);
            addPerspectiveLead(leadObj);
        }
    };
    // const goBackHeaderButtonClicked = () => {
    //   const currentStepKey =
    //     step?.label === 'contact' ? 'contactInfo' : step?.label.toLocaleLowerCase();
    //   if (currentStepKey === 'make') {
    //     router.push(`/${lang}/sell-car`);
    //     return;
    //   }
    //   goBackToPreviousStep(currentStepKey as keyof IStepper_SELL);
    // };
    const showNewMap = getShowNewMap();

    const thankyouReached =
        (isSuccessAddLead && getPath() === 'path1') ||
        (isSuccessAddPerspectiveLead && getPath() === 'path2');

    return (
        <div>
            <SellCarMobileHeader
                thankyouReached={thankyouReached}
                goBack={goBackToPreviousStep}
            />
            <Conditional condition={!thankyouReached}>
                <>
                    <StepperSteps
                        stepper={getStepper()}
                        totalSteps={getStepper().length}
                        label={step?.label}
                        icon={step?.icon}
                        step={step?.step}
                        backgroundColor={step?.backgroundColor}
                        mainIcon={step?.mainIcon}
                        path={getPath()}
                        goToSpecificStep={goToTargetStep}
                    />

                    {step?.label === 'inspectionType' && (
                        <SellFormMobileContetnLayout
                            formContent={
                                <SelectInspectionType
                                    // label={t('InspectionType')}
                                    path={getPath()}
                                    formFunction={setChoosenData}
                                />
                            }
                            header={t('selectYourInspectionType')}
                        />
                    )}
                    {step?.label === 'make' && (
                        <SellFormMobileContetnLayout
                            formContent={
                                <SelectFormContent
                                    open={false}
                                    searchPlaceholder={t('search')}
                                    formFunction={setChoosenData}
                                    formContent={makesState}
                                    step={'make'}
                                    disclaimerText={getDisclaimerText()}
                                    shouldShowAlert={false}
                                    intialValue={buildFormDataObjectFromMakeModel(
                                        getMake()
                                    )}
                                    searchIncluded={true}
                                    subtitle={''}
                                />
                            }
                            header={t('whats your car make')}
                        />
                    )}
                    {step?.label === 'model' && (
                        <SellFormMobileContetnLayout
                            header={t('pick your model')}
                            formContent={
                                <SelectFormContent
                                    open={false}
                                    searchPlaceholder={t('search')}
                                    formFunction={setChoosenData}
                                    formContent={modelstate}
                                    step={'model'}
                                    disclaimerText={getDisclaimerText()}
                                    shouldShowAlert={false}
                                    intialValue={buildFormDataObjectFromMakeModel(
                                        getModel()
                                    )}
                                    searchIncluded={true}
                                    subtitle={''}
                                />
                            }
                        />
                    )}
                    {step?.label === 'year' && modelsData?.data && (
                        <SellFormMobileContetnLayout
                            header={t('pick your car year')}
                            formContent={
                                <SelectFormContent
                                    open={false}
                                    searchPlaceholder={t('search')}
                                    formFunction={setChoosenData}
                                    formContent={getYearsKmFromTargetModel(
                                        modelsData?.data
                                    )}
                                    step={'year'}
                                    disclaimerText={getDisclaimerText()}
                                    shouldShowAlert={false}
                                    intialValue={buildFormDataObjectFromYear(
                                        getYear()
                                    )}
                                    searchIncluded={true}
                                    subtitle={''}
                                />
                            }
                        />
                    )}
                    {step?.label === 'kilometers' && modelsData?.data && (
                        <SellFormMobileContetnLayout
                            header={t('pick your car kilometrage')}
                            formContent={
                                <SelectFormContent
                                    open={false}
                                    searchPlaceholder={t('search')}
                                    formFunction={setChoosenData}
                                    formContent={getKmFromTargetModel(
                                        modelsData?.data
                                    )}
                                    // formContent={getKmFromTargetModel(BMW_MODEL)}
                                    step={'kilometers'}
                                    disclaimerText={getDisclaimerText()}
                                    shouldShowAlert={false}
                                    intialValue={buildFormDataObjectFromKilometers(
                                        getKilometers()
                                    )}
                                    searchIncluded={true}
                                    subtitle={''}
                                />
                            }
                        />
                    )}

                    {step?.label === 'otherinfo' && modelsData?.data && (
                        <SellFormMobileContetnLayout
                            header={t('otherinfo')}
                            formContent={
                                <>
                                    <SelectFormContent
                                        open={false}
                                        searchPlaceholder={t('search')}
                                        formFunction={setChoosenData}
                                        formContent={transmissionState}
                                        step={'transmission'}
                                        disclaimerText={getDisclaimerText()}
                                        shouldShowAlert={false}
                                        intialValue={buildFormDataObjectFromTransmission(
                                            getTransmission()
                                        )}
                                        searchIncluded={false}
                                        subtitle={''}
                                    />

                                    <Conditional
                                        condition={
                                            getTransmission().transmission !==
                                            ''
                                        }
                                    >
                                        <SelectFormContent
                                            formContent={trafficPointState}
                                            step={'trafficPoint'}
                                            formFunction={setChoosenData}
                                            searchPlaceholder={''}
                                            open={true}
                                            disclaimerText={''}
                                            shouldShowAlert={false}
                                            intialValue={buildFormDataObjectFromTrafficPoint(
                                                getTrafficPoint()
                                            )}
                                            searchIncluded={false}
                                            subtitle={t('Traffic Point')}
                                        />
                                    </Conditional>
                                </>
                            }
                        />
                    )}
                    {regions && step.label === 'region' && (
                        <SellFormMobileContetnLayout
                            header={t('your location')}
                            formContent={
                                showNewMap ? (
                                    <LocationMapForm
                                        region={getRegion()}
                                        formFunction={setChoosenData}
                                        formContent={locationsState}
                                        step={'region'}
                                        open={false}
                                        disclaimerText={getDisclaimerText()}
                                        searchPlaceholder={t('search')}
                                        intialValue={buildFormDataObjectFromRegion(
                                            getRegion()
                                        )}
                                    />
                                ) : (
                                    <LocationFormContent
                                        region={getRegion()}
                                        formFunction={setChoosenData}
                                        formContent={locationsState}
                                        step={'region'}
                                        open={false}
                                        disclaimerText={getDisclaimerText()}
                                        searchPlaceholder={t('search')}
                                        intialValue={buildFormDataObjectFromRegion(
                                            getRegion()
                                        )}
                                    />
                                )
                            }
                        />
                    )}
                    {step?.label === 'contactInfo' &&
                        !isSuccessAddPerspectiveLead &&
                        !isSuccessAddLead && (
                            <SellFormMobileContetnLayout
                                header={t('contactInfoHeader')}
                                formContent={
                                    <ContactInfoForm
                                        errorMessage={
                                            getPath() === 'path1'
                                                ? errorAddLead
                                                : errorAddPerspectiveLead
                                        }
                                        isError={
                                            getPath() === 'path1'
                                                ? isErrorAddLead
                                                : isErrorAddPerspectiveLead
                                        }
                                        isLoading={
                                            getPath() === 'path1'
                                                ? isLoadingAddLead
                                                : isLoadingAddPerspectiveLead
                                        }
                                        path={getPath()}
                                        formFunction={submitForm}
                                        step={'contactInfo'}
                                    />
                                }
                            />
                        )}
                </>
            </Conditional>
        </div>
    );
};

export default SellCarForm;
